import {
  Artist,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";

export const isMixedModelTypeGuard = (
  mixedModelMaybe:
    | Artist
    | Instrument
    | ModelNoDates
    | MixedModelConstructedNoDates
): mixedModelMaybe is MixedModelConstructedNoDates => {
  return "presignedUrlMixedModel" in mixedModelMaybe;
};
